export default "__VITE_ASSET__36626a02__"